import { useAuthStore } from '@/stores/auth';

const BASE_URL = 'https://reserve.dartclubwisla.pl';

export const fetchWrapper = {
    get: request('GET'),
    post: request('POST'),
    put: request('PUT'),
    delete: request('DELETE')
};

function request(method) {
    return (url, body) => {
        const requestOptions = {
            method,
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: "include",
        };

        if (body) {
            requestOptions.body = JSON.stringify(body);
        }

        return fetch(`${BASE_URL}${url}`, requestOptions).then(handleResponse);
    };
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);

        if (!response.ok) {
            const authStore = useAuthStore();
            if ([401, 403].includes(response.status) && authStore.user) {
                // Auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                authStore.logout();
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}